<template>
  <div class="followlist">
    <!-- 巡更棒 -->
    <div class="followlist-m">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        @submit.native.prevent
      >
        <el-form-item label="设备编号">
          <el-input
            v-model.trim="formInline.inputdeviceno"
            placeholder="请输入设备编号"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            plain
            @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="warning"
            plain
            class="el-icon-plus"
            @click="dialogFormVisible = true"
            >新增</el-button
          >
          <el-button type="info" icon="el-icon-upload" plain @click="intoList"
            >导入</el-button
          >
          <el-button type="info" icon="el-icon-document" plain @click="downLoad"
            >表格模板下载</el-button
          >
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <div class="table-page">
          <el-table
            :data="list"
            style="width: 100%"
            :row-style="tableRowStyle"
            :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
            :header-cell-style="tableHeaderColor"
          >
            <el-table-column
              label="设备编号"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.deviceNo }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="设备名称"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.deviceName
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="设备描述"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.remark }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="使用人"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  style="margin-left: 10px; color: orange"
                  v-if="scope.row.userName == null"
                  >暂未绑定</span
                >
                <span style="margin-left: 10px" v-else>{{
                  scope.row.userName
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="400" align="center">
              <template slot-scope="scope">
                <!-- icon="el-icon-edit" -->
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >

                <!-- icon="el-icon-delete" -->
                <el-button
                  type="danger"
                  size="mini"
                  plain
                  @click="handleDelete(scope.$index, scope.row)"
                  >删除</el-button
                >
                <!-- icon="el-icon-goods" -->
                <el-button
                  type="success"
                  size="mini"
                  v-if="!scope.row.userName"
                  plain
                  @click="bindingEquipment(scope.$index, scope.row)"
                  >绑定</el-button
                >
                <!-- icon="el-icon-sold-out" -->
                <el-button
                  type="info"
                  size="mini"
                  v-if="scope.row.userName"
                  plain
                  @click="handleJiebang(scope.$index, scope.row)"
                  >解绑</el-button
                >
                <!-- icon="el-icon-sold-out" -->
                <el-button
                  type="primary"
                  size="mini"
                  plain
                  @click="tourTimeSet(scope.$index, scope.row)"
                  >巡更棒时间设置</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>
      <!-- 弹出新增 -->
      <el-dialog
        title="新增设备信息"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="followxz"
        @close="closexz"
      >
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item
            label="设备编号"
            :label-width="formLabelWidth"
            prop="xzdate"
          >
            <el-input
              v-model.trim="form.xzdate"
              placeholder="请输入设备编号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="设备名称"
            :label-width="formLabelWidth"
            prop="xzname"
          >
            <el-input
              v-model.trim="form.xzname"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="设备描述"
            :label-width="formLabelWidth"
            prop="xzsec"
          >
            <el-input
              v-model.trim="form.xzsec"
              type="textarea"
              :rows="3"
              placeholder="请输入设备描述"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelxz">取 消</el-button>
          <el-button
            type="primary"
            @click="submitForm('form')"
            :loading="addLoading"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- 弹出修改 -->
      <el-dialog
        title="修改设备信息"
        :visible.sync="dialogFormEdit"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="followedit"
      >
        <el-form ref="formedit" :model="formedit" :rules="rules">
          <el-form-item
            label="设备编号"
            :label-width="formLabelWidth"
            prop="editdate"
          >
            <el-input
              disabled
              v-model.trim="formedit.editdate"
              auto-complete="off"
              placeholder="请输入设备编号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="设备名称"
            :label-width="formLabelWidth"
            prop="editname"
          >
            <el-input
              v-model.trim="formedit.editname"
              auto-complete="off"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="设备描述"
            :label-width="formLabelWidth"
            prop="editsec"
          >
            <el-input
              v-model.trim="formedit.editsec"
              auto-complete="off"
              type="textarea"
              :rows="3"
              placeholder="请输入设备描述"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="dialogFormEdit = false">取 消</el-button>
          <el-button
            type="primary"
            @click="submitFormEdit('formedit')"
            :loading="editLoading"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- 弹出绑定设备 -->
      <el-dialog
        title="绑定巡更棒"
        :visible.sync="dialogFormBind"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="followedit"
        @closed="bindClosed"
      >
        <el-form ref="formbind" :model="formbind" :rules="rules">
          <el-form-item
            label="设备编号"
            :label-width="formLabelWidth"
            prop="binddate"
          >
            <el-input
              disabled
              v-model.trim="formbind.binddate"
              auto-complete="off"
              placeholder="请输入设备编号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="使用人"
            :label-width="formLabelWidth"
            prop="userId"
          >
            <el-select
              v-model="formbind.userId"
              placeholder="请选择"
              style="width: 100%"
              @change="bindChange"
            >
              <el-option
                v-for="item in bindOptions"
                :key="item.oldmanId"
                :label="item.oldName"
                :value="item.oldmanId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="dialogFormBind = false">取 消</el-button>
          <el-button
            type="primary"
            @click="submitFormBind('formbind')"
            :loading="BindLoading"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <!-- 表格导入的dialog -->
      <el-dialog
        title="设备导入"
        width="30%"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        @close="closeDialogReset"
      >
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-row>
              <el-col :span="24">
                <input type="file" ref="file" id="file" @change="getUrl" />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click.native="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click.native="intoForm">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import iTable from "@/components/iTable.vue";
import bus from "@/vuex/eventBus";
import { baseURL } from "@/utils/request.js";
export default {
  data() {
    return {
      addLoading: false,
      BindLoading: false,
      editLoading: false,
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 8, //每页显示的条数
      deviceno: "",
      list: [], //返回的结果集合
      totalDataNumber: 0, //数据的总数,
      loading: "", //加载数据中
      formInline: {
        inputdeviceno: "",
      },
      // 新增表单dialog
      dialogFormVisible: false,
      dialogVisible: false,
      form: {
        xzdate: "",
        xzsec: "",
        xzname: "",
      },
      formLabelWidth: "120px",
      //修改表单dialog
      dialogFormEdit: false,
      formedit: {
        editdate: "",
        editname: "",
        editsec: "",
      },
      //绑定设备表单dialog
      dialogFormBind: false,
      formbind: {
        binddate: "",
        userId: "",
      },
      bindOptions: [],
      rules: {
        // 新增正则验证匹配规则
        xzdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          //可以设置双重验证标准
          //{min: 5, max:15, message: '长度在 5到 15 个字符'},
          // { pattern: /^[A-Za-z0-9_]+$/, message: '请输入由数字、字母、下划线组成的字符' }
          //{ pattern: /^[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' },
          //{ pattern: /^HC/, message: '请输入由HC开头的字符' }
          { min: 1, max: 30, message: "长度在 1到 30 个字符" }, //by  guo 2020-4-26-18:12修改
        ],
        xzname: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 30, message: "长度在 1到 30 个字符" },
        ],
        xzsec: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 100, message: "长度在 1到 100 个字符" },
        ],

        // 修改正则验证匹配规则
        editdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          //可以设置双重验证标准
          //{ min: 5, max:15,  message: '长度在 5到 15 个字符', },
          // { pattern: /^[A-Za-z0-9_]+$/, message: '请输入由数字、字母、下划线组成的字符' }
          //{ pattern: /^[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' }
          // { pattern: /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[_-])[a-z0-9_-]+$/gi, message: '请输入由数字,大小写字母和_或-组成的字符' }
          { min: 1, max: 30, message: "长度在 1到 30 个字符" }, //by  guo 2020-4-26-18:12修改
        ],
        editname: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 30, message: "长度在 1到 30 个字符" },
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ],
        editsec: [
          // {
          //   required: true, //是否必填
          //   message: "不能为空", //规则
          //   trigger: "blur" //何事件触发
          // },
          //可以设置双重验证标准
          { min: 1, max: 100, message: "长度在 1到 100 个字符" },
          // { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, message: '不允许输入空格等特殊符号' }
        ],

        // 绑定设备
        binddate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
        ],
        userId: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "change", //何事件触发
          },
        ],
      },
      fileFlag: false,
    };
  },
  methods: {
    // 选中行
    handleSelectionChange(val) {
      console.log("val:", val);
    },

    //点击查询
    onSubmit(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (this.formInline.inputdeviceno == "") {
        this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
      } else {
        this.getTableData(
          this.formInline.inputdeviceno,
          (this.pageNum = 1),
          (this.pageSize = 8)
        );
      }
    },

    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.inputdeviceno != null) {
        if (this.formInline.inputdeviceno == "") {
          this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
        } else {
          this.getTableData(
            this.formInline.inputdeviceno,
            (this.pageNum = 1),
            (this.pageSize = 8)
          );
        }
      }
    },
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    //查询部门信息
    getDepartInfo() {
      let param = {};
      this.$postForm("uac/dept/getDeptVoAll", param).then((res) => {
        console.log(res);
        if (res.code === 200) {
          var deptId = res.result[0].id; //获取父级部门的id,用来获取所有的员工信息
          console.log(deptId);
          this.getEmployeeList(deptId);
        }
      });
    },
    //获取所有员工信息
    getEmployeeList(deptId) {
      let param = {
        pageNum: "0",
        pageSize: "0",
        deptId: deptId,
      };
      this.$postJson("uac/emp/queryUserListByEmpWithPage", param).then(
        (res) => {
          console.log(res.result.list);
          // this.oldmanList = res.result.list;
          var arroldNameId = [];
          var objoldNameId = {};
          res.result.list.forEach((item, index) => {
            objoldNameId = {
              oldName: item.userName,
              oldmanId: item.userId,
              oldIdCard: item.idCard,
            };
            arroldNameId.push(objoldNameId);
          });
          console.log(arroldNameId);
          //深拷贝两个数组去操作select菜单 员工的绑定时 ，将员工删除  解除绑定时，将员工重新添加进员工select菜单中
          this.bindOptions = Object.assign([], arroldNameId); //拷贝记录
          console.log(this.bindOptions);
        }
      );
    },
    bindChange(value) {
      console.log(value);
      this.bindOptions.forEach((item) => {
        if (item.oldmanId == value) {
          this.formbind.userName = item.oldName;
        }
      });
    },
    // 绑定设备
    bindingEquipment(index, row) {
      this.dialogFormBind = true;
      // this.formbind = Object.assign({}, row); //深拷贝记录
      console.log(this.formedit.id);
      //将对应行所对的表格值赋给input框
      //   this.$set(this.formedit, "binddate", row.deviceNo);
      this.formbind.binddate = row.deviceNo;
      this.formbind.deviceId = row.id;
      this.getDepartInfo();
    },
    bindClosed() {
      console.log("gaunbi l ");
      this.formbind = {};
      this.$refs.formbind.resetFields(); //移除校验结果并重置字段值
    },
    submitFormBind(formName) {
      //正则匹配规则rules
      this.$refs[formName].validate((valid) => {
        //判断数据是否存在
        if (valid) {
          // return console.log(this.formbind, "formbind");
          let param = {
            bindType: 1,
            userId: this.formbind.userId,
            userName: this.formbind.userName,
            deviceId: this.formbind.deviceId,
          };
          console.log(param);
          this.BindLoading = true;
          this.$postJson("dmc/patrol/bind", param).then((res) => {
            console.log(res);
            this.BindLoading = false;
            this.dialogFormBind = false; //关闭修改弹窗
            // this.$bus.$emit("submitFormEditchange_follow"); //发送一个change事件
            this.getTableData();
            if (res.code == "200") {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "success",
                });
              }, 300);
              console.log("修改成功!");
            } else {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }, 300);
            }
          });
        } else {
          console.log("修改失败!");
          return false;
        }
      });
    },
    //解绑人员的绑定
    handleJiebang(index, row) {
      console.log(row, "row");
      this.$confirm("此操作将解除绑定, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false,
      })
        .then(() => {
          // this.formBangdi = Object.assign({}, row); //拷贝数据
          let params = {
            deviceId: Number(row.id),
          };
          this.$postJson("dmc/patrol/untied", params).then((res) => {
            console.log(res);
            this.$set(this.formedit, "status", true);
            this.getTableData();
            if (res.code == 200) {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "success",
                });
              }, 300);
            } else {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }, 300);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消解除绑定",
          });
        });
    },
    // 巡更棒时间设置
    tourTimeSet(index, row) {
      this.formedit = Object.assign({}, row); //深拷贝数据
      var id = this.formedit.id;
      bus.$emit("homePage", {
        type: "jump",
        path: "/TourTimeSetting",
        title: "巡更时间设置",
        params:{
          id: id 
        }
      });
    },

    // 点击弹出修改信息的弹窗
    handleEdit(index, row) {
      (this.dialogFormEdit = true), //打开修改弹窗
        console.log(index, row);
      this.listIndex = index; //记录索引
      console.log(this.listIndex);
      // this.formedit=row;//记录数据
      this.formedit = Object.assign({}, row); //深拷贝记录
      console.log(this.formedit.id);
      //将对应行所对的表格值赋给input框
      this.$set(this.formedit, "editdate", row.deviceNo);
      this.$set(this.formedit, "editsec", row.remark);
      this.$set(this.formedit, "editname", row.deviceName);
      console.log(this.formedit.editdate);
    },

    //点击修改弹窗的 确定按钮提交修改的数据
    submitFormEdit(datainfo) {
      //正则匹配规则rules
      this.$refs[datainfo].validate((valid) => {
        //判断数据是否存在
        if (valid) {
          let param = {
            id: this.formedit.id,
            remark: this.formedit.editsec,
            deviceName: this.formedit.editname,
            deviceNo: this.formedit.editdate,
          };
          console.log(param);
          this.editLoading = true;
          this.$postJson("dmc/follow/edit", param).then((res) => {
            console.log(res);
            this.editLoading = false;
            this.dialogFormEdit = false; //关闭修改弹窗
            // this.$bus.$emit("submitFormEditchange_follow"); //发送一个change事件
            this.getTableData();
            if (res.code == "200") {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "success",
                });
              }, 300);
              console.log("修改成功!");
            } else {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }, 300);
            }
            //console.log(this.$store.state.count)
          });
        } else {
          console.log("修改失败!");
          return false;
        }
      });
    },

    //删除
    handleDelete(index, row) {
      if (row.bindType == null) {
        this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false,
        })
          .then(() => {
            console.log(index, row);
            let id = row.id;
            console.log(id);
            this.$postJson(`dmc/propertyManagement/untie`, {
              deviceIds: [id],
            }).then((res) => {
              //旧 dmc/follow/deleteById/
              if (res.code == 200) {
                // this.$bus.$emit("handleDeletechange_follow"); //发送一个change事件
                this.getTableData();
                console.log(res);
                this.$message({
                  type: "success",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "error",
          message: "该设备已经被绑定，请先解绑后再进行删除!",
        });
      }
    },

    //关闭新增的dialog
    closexz() {
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //点击新增取消  重置表单以及验证
    cancelxz() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    //新增弹出框点击确定提交信息
    submitForm(datainfo) {
      this.$refs[datainfo].validate((valid) => {
        if (valid) {
          let param = {
            remark: this.form.xzsec,
            deviceName: this.form.xzname,
            deviceNo: this.form.xzdate,
          };
          console.log(param);
          //this.loading = true
          this.addLoading = true;
          this.$postJson("dmc/propertyManagement/bindDeviceMerchant", param)
            .then((res) => {
              //旧: dmc/follow/add
              console.log(res);
              this.addLoading = false;
              this.dialogFormVisible = false;
              this.$refs.form.resetFields(); //移除校验结果并重置字段值
              // this.$bus.$emit("submitFormchange_follow"); //发送一个change事件
              this.getTableData();
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success",
                  });
                }, 300);
                console.log("提交成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error",
                  });
                }, 300);
              }
              //console.log(this.$store.state.count)
              //this.loading = false
            })
            .catch((res) => {
              this.$message({
                type: "error",
                message: res.message,
              });
            });
        } else {
          console.log("提交失败!");
          return false;
        }
      });
    },

    //获取表格数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceNo: this.formInline.inputdeviceno,
      };
      console.log(param);
      this.loading = true;
      this.$postJson("dmc/patrol/queryGroupPatrolListWithPage", param).then(
        (res) => {
          console.log(res);
          //判断是否有数据
          if (res.result.list.length != 0) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            this.list = res.result.list;
            //this.$set(this.tableData,res.result.list)
            console.log(this.list);
            setTimeout(() => {
              this.loading = false;
            }, 500);
          } else {
            this.list = [];
            this.totalDataNumber = 0;
            setTimeout(() => {
              this.loading = false;
            }, 3000);
          }
        }
      );
    },

    //导入
    intoList() {
      this.dialogVisible = true;
    },

    //确认导入
    getUrl(event) {
      let file = event.target.files;
      console.log(file);
      this.fileFlag = true; //by guo 2020-8-4-15:18添加
      this.formData = new FormData();
      this.formData.append("file", file[0]);
    },

    //确认导入
    intoForm() {
      if (this.fileFlag) {
        this.$postFormData(
          "dmc/propertyManagement/merchantToLead",
          this.formData
        ).then((res) => {
          this.dialogVisible = false;
          this.formData = {};
          this.fileFlag = false;
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
            this.getTableData();
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        });
      } else {
        this.$message({ message: "请选择文件", type: "error" });
      }
    },

    closeDialogReset() {
      this.$refs.file.value = ""; // 清空file文件
    },

    //模板下载
    downLoad() {
      window.location.href = baseURL + "dmc/api/downTemplate";
    },

    //初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getTableData();
    },
  },

  watch: {
    currentPage(newV, oldV) {
      console.log(newV, oldV);
      deep: true; //深度监听
    },
    //  tableData(newV,oldV) {
    //      console.log(newV,oldV);
    //      deep: true  //深度监听
    // },
    data: "onSubmit", //值可以为methods的方法
  },

  created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.getTableData();
  },

  mounted() {
    //监听submitFormchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
    this.$bus.$on("submitFormchange_follow", () => {
      this.getTableData();
    }),
      //监听handleDeletechange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
      this.$bus.$on("handleDeletechange_follow", () => {
        this.getTableData();
      }),
      //监听submitFormEditchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
      this.$bus.$on("submitFormEditchange_follow", () => {
        this.getTableData();
      }),
      this.getTableData();
  },
  components: { iTable },
};
</script>
<style lang="scss" scoped>
.followlist {
  .followlist-m {
    padding: 10px 0 0 5px;
  }
}

// 修改element-ui默认的样式
.del {
  color: red !important;
}
.fangqu {
  color: green !important;
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
//  ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

//新增的dialog
@media screen and (min-width: 1200px) {
  ::deep .followxz .el-dialog {
    width: 30% !important;
  }
}

//修改的dialog
@media screen and (min-width: 1200px) {
  ::deep .followedit .el-dialog {
    width: 30% !important;
  }
}
</style>
